import { stringCompare } from '@mahawi/eshop-common/src/string-compare';
import { type ITag } from '@mahawi/eshop-common/src/types';
import { createSlice } from '@reduxjs/toolkit';

import {
  asyncStateInitial,
  finishLoading,
  requestFailedMatcher,
  resetLoadingOnRequestFailed,
  startLoading,
} from '../async-state';
import { type ITagsState } from './types';

export const preloadedState: ITagsState = {
  ...asyncStateInitial,
  tags: undefined,
};

const tagsSlice = createSlice({
  name: 'Tags',
  initialState: preloadedState,
  reducers: {
    tagsAdd: {
      reducer(state) {
        startLoading(state);
      },
      prepare(name: string, color: string) {
        return { payload: { name, color } };
      },
    },
    tagsAddResponse: {
      reducer(state, action: { payload: { tag: ITag | null } }) {
        if (Array.isArray(state.tags) && action.payload.tag) {
          state.tags.unshift(action.payload.tag);
        }
        finishLoading(state);
      },
      prepare(tag: ITag | null) {
        return { payload: { tag } };
      },
    },
    tagsLoadAll(state) {
      startLoading(state);
      state.tags = undefined;
    },
    tagsLoadAllResponse: {
      reducer(state, action: { payload: { tags: ITag[] } }) {
        state.tags = action.payload.tags.sort((a: ITag, b: ITag): number =>
          stringCompare(a.name, b.name),
        );
        finishLoading(state);
      },
      prepare(tags: ITag[]) {
        return { payload: { tags } };
      },
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      requestFailedMatcher('Tags'),
      resetLoadingOnRequestFailed,
    );
  },
});

export const { tagsAdd, tagsAddResponse, tagsLoadAll, tagsLoadAllResponse } =
  tagsSlice.actions;
export default tagsSlice.reducer;
